import { AtomicBlockUtils } from 'draft-js';

var insertAtomicBlock = function insertAtomicBlock(editorState, entityType, mutability, data) {
  var character = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ' ';

  var entityKey = editorState.getCurrentContent().createEntity(entityType, mutability, data).getLastCreatedEntityKey();
  return AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, character);
};

export default insertAtomicBlock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/insertAtomicBlock.js
// module id = 243
// module chunks = 0